<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid style="margin-top: 5%;">
			<b-row class="mt-3 mb-2">
				<b-col class="col-md-6 col-sm-6 col-xs-6">
					<h3>Manage GPS Schedule</h3>
				</b-col>
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
					<!-- <b-button variant="dark" pill class="mr-2" @click="showAddModal()">Add GPS Schedule</b-button> --> 

					<span class="mr-2 ">Schedule:</span>
					
									<!-- ON: {{row.item.output_status}} -->		
									 <!-- off:{{row.item.output_status}} -->	 					
								<span v-if="firstRecord.schedule_applied==1">
									
									<toggle-button  :value="true" name="222" @change="onChangeEventHandler($event)" :sync="true" :labels="{checked: 'GPS Schedule Applied', unchecked: 'GPS Schedule'}" :color="{checked: '#28a745', unchecked: '#dc3545'}" :width="200" :height="30" />
								</span>
								<span v-else >
									
									<toggle-button :value="false" name="222" @change="onChangeEventHandler($event)" :sync="true" :labels="{checked: 'Manual Schedule Applied', unchecked: 'Manual Schedule'}" :color="{checked: '#28a745', unchecked: '#dc3545'}" :width="200" :height="30" />

								</span> 
						
				</b-col>
			</b-row>
		</b-container>
		<b-container fluid>
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
					<div class="container-box">
						<b-row class="mt-4 px-3">
							<b-col lg="6">
								<span class="mr-2">Show</span>
								<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
								</b-form-select>
								<span class="ml-2">entries</span>
							</b-col>
							<b-col lg="4" offset-md="2">
								<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
									<b-input-group size="sm">
										<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
										</b-form-input>
										<b-input-group-append>
											<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row class="px-3 pt-3">
							<b-col lg="12">
								<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
									<template v-slot:cell(ulb_id)="row">
										<b-label>{{getUlbLabel(row.value)[0].title}}</b-label>
									</template>
                                    <template v-slot:cell(status)="row">
										<b-badge pill variant="danger" v-if="row.value == 0">INACTIVE</b-badge>
										<b-badge pill variant="success" v-else>ACTIVE</b-badge>
									</template>
									<template v-slot:cell(actions)="row">
										<b-button pill variant="primary" class="mr-1" @click="showUpdateModal(row.item, row.index, $event.target)" size="sm">EDIT</b-button>
										<!-- <b-button pill variant="danger" class="mr-1" @click="showDeleteModal(row.item)" size="sm">DELETE</b-button> -->
									</template>
								</b-table>
							</b-col>
						</b-row>
						<b-row class="px-3">
							<b-col lg="6">
								<span class="mr-2">Showing {{currentPage}} to {{(perPage>records.length)?records.length:perPage}} of {{records.length}} entries</span>
							</b-col>
							<b-col lg="3" offset-md="3">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>

			<!-- <b-row>
				<b-col>
					<div class="card">
						<h2>🌤️ Weather App</h2>

						
						<select v-model="city">
						<option value="">Select a city</option>
						<option v-for="c in cities" :key="c" :value="c">
							{{ c }}
						</option>
						</select>

						<button @click="getWeather">Get Weather</button>

						<div class="weather" v-if="message">
						{{ message }}
						</div>

						<div class="weather" v-if="weather">
						<div class="row"><span class="label">City:</span> {{ weather.city }}</div>
						<div class="row"><span class="label">Temperature:</span> {{ weather.temp }} °C</div>
						<div class="row"><span class="label">Feels Like:</span> {{ weather.feels }} °C</div>
						<div class="row"><span class="label">Condition:</span> {{ weather.condition }}</div>
						<div class="row"><span class="label">Humidity:</span> {{ weather.humidity }}%</div>
						<div class="row"><span class="label">Wind:</span> {{ weather.wind }} km/h</div>
						<div class="row"><span class="label">Sunrise:</span> {{ weather.sunrise }}</div>
						<div class="row"><span class="label">Sunset:</span> {{ weather.sunset }}</div>
						</div>
					</div>

				</b-col>
			</b-row> -->


			<b-modal id="my-model" :title="(selectedItem.id > 0)?'Edit GPS Schedule':'Add GPS Schedule'" ok-only @hidden="resetSelectedItem" @ok="modalSubmit">
				<form ref="form" @submit.stop.prevent="handleSubmit">
					
						
						<div class="weather" v-if="message">
						{{ message }}
						</div>
						<b-form-group
						id="input-group-city"
						label="Select City"
						label-for="city-select"
						label-cols="3"
						label-size="sm"
						label-align-sm="right"
						v-if="selectedItem.schedule_type==1"
						>
						 <div class="d-flex gap-2">
							<b-form-select
							id="city-select"
							v-model="city"
							:options="cityOptions"
							size="sm"
							required
							/>
							<b-input-group-append>
								<b-button
								variant="primary"
								size="sm"
								@click="getWeather" style="width: 65px;"
								>
								Get <b-icon icon="clock" font-scale="1" class="me-1"></b-icon>
								</b-button>
    						</b-input-group-append>

							</div>
						
						</b-form-group>

						<b-form-group label="City Name" label-for="title" label-cols="3" label-size="sm" label-align-sm="right" invalid-feedback="Name is required" >
						<b-form-input v-model="selectedItem.name" required disabled></b-form-input>
						</b-form-group>
					<b-form-group 
						id="input-group-2" 
						label="ON Time" 
						label-for="type-ontime" 
						label-cols="3" 
						label-size="sm" 
						label-align-sm="right"
						
						>
							<b-form-input 
							id="type-ontime" 
							type="time" 
							size="sm" 
							required 
							v-model="selectedItem.on_time"
							
							></b-form-input>
						</b-form-group>
						<b-form-group 
						id="input-group-3" 
						label="OFF Time" 
						label-for="type-ontime" 
						label-cols="3" 
						label-size="sm" 
						label-align-sm="right" >
							<b-form-input 
							id="type-ontime" 
							type="time"
							size="sm" 
							required 
							v-model="selectedItem.off_time"
							></b-form-input>
						</b-form-group>
						<b-form-group 
						id="input-group-3" 
						label="Twilight Time" 
						label-for="type-ontime" 
						label-cols="3" 
						label-size="sm" 
						label-align-sm="right" v-if="selectedItem.schedule_type==1" >
							<b-form-input 
							id="type-ontime" 
							type="time"
							size="sm" 
							required 
							v-model="selectedItem.tubelight_time"
							></b-form-input>
						</b-form-group>
					
					<!-- <b-form-group label="Status" label-for="status" label-cols="3" label-size="sm" label-align-sm="right">
						<b-form-select v-model="selectedItem.status" :options="statusOptions" required></b-form-select>
					</b-form-group> -->
				</form>
				<template v-slot:modal-footer="{ ok, close }">
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
					<b-button size="sm" variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>
				</template>
			</b-modal>
		
		</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
	</div>
	
</template>
<script>
import { ToggleButton } from 'vue-js-toggle-button'
import Header from "@/components/Header.vue";
export default {
	name: 'Wards',
	components: {
		"top-header": Header,
		ToggleButton
	},
	mounted(){
		var self = this;
		Object.assign(self.selectedItem, self.emptyItem);
        //this.loadzones()
		this.initload();
	},
	data() {
		var self = this;
		return{
			API_KEY: "zpka_e8b0a8df890e4f11abe51c8b51f34875_ce502675",
			city: "",
			cities: ["London", "New York", "New Delhi", "Mumbai", "Dubai", "Tokyo", "Paris"],
			cityOptions:["Ahmedabad","Bengaluru","Bhopal","Chennai","Ghaziabad","Hyderabad","Indore","Jaipur","Jabalpur","Kanpur","Kolkata","Lucknow","Ludhiana","Mumbai","Nagpur","New Delhi","Patna","Pimpri-Chinchwad","Pune","Raipur","Ranchi","Surat","Vadodara","Visakhapatnam"],
			message: "",
			weather: null,
			loading: true, 
			email: '',
			password: '',
			firstRecord:[],
			recordUrl: self.$session.get('apiurl')+'esmartapi/schedule',
			insertUrl: self.$session.get('apiurl')+'esmartapi/schedule-add',
			updateUrl: self.$session.get('apiurl')+'esmartapi/schedule-edit',
			deleteUrl: self.$session.get('apiurl')+'esmartapi/schedule-remove',
			scheduleUrl: self.$session.get('apiurl')+'esmartapi/schedule-set',
            zones: [],
			records: [],
			statusOptions: [{ value: 0, text: 'Disabled' },{ value: 1, text: 'Enabled' }],
			zoneOptions: [],
			fields: [
				/* { key: 'id', label: 'ID'}, */
				{ key: 'schedule_type', label: 'Schedule Mode',class:"text-center",
				formatter: (value) => { 
						var sec = 'Manual';
						if(value==1){
							sec = 'GPS';							
						}
						return sec;
					},
				},
				{ key: 'name', label: 'City Name',class:"text-center",},
				{ key: 'on_time', label: 'ON Time ',class:"text-center",					
				 },
				{ key: 'off_time', label: 'OFF Time',class:"text-center",					
				},
				{ key: 'tubelight_time', label: 'Twilight Time',class:"text-center", },				
				/* {key:'total_ccms',lable:'Total CCMS',class:"text-center"}, */
				/* { key: 'status', label: 'Status' }, */
				{ key: 'actions', label: 'Actions', class:"text-center", 'extra': 1 }
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {},
			emptyItem: {
				id: 0,
                name: '',
				on_time: '00:00',
				off_time: '00:00',
				tubelight_time:'00:00',
				/* status: 0 */
			}
		};
	},
	methods: {
        getUlbLabel: function(value){
            return this.zones.filter(function (item) {
				return item.id  == value;
			})
        },
		filterULB: function (items) {
			var self = this;
			return items.filter(function (item) {
				return item.state  == self.selectedItem.state_id;
			})
		},
		showAddModal(){
			this.selectedItem = Object.assign({}, this.emptyItem);
			this.$root.$emit('bv::show::modal', 'my-model');
		},
		showUpdateModal(item, index, button) {
			//var self = this;
			this.city = item.name;
            this.selectedItem = Object.assign({}, item);
           
			this.$root.$emit('bv::show::modal', 'my-model', button)
		},
		showDeleteModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to delete Group.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.deleteUrl, {
						accesskey: self.$session.get('access_key'),
						deleteid: item.id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				alert(err);
				//console.log(err);
			})
		},
		modalSubmit(bvModalEvt){
			var self = this;
			self.loading = true;
			bvModalEvt.preventDefault();
			var submitUrl = "";
			if(self.selectedItem.id == 0){
				submitUrl = self.insertUrl;
			}else{
				submitUrl = self.updateUrl;
			}


			self.axios.post(submitUrl, {
				accesskey: self.$session.get('access_key'),
				data: self.selectedItem
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('my-model');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.initload();
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		onChangeEventHandler(event){
			var self = this;
			self.loading = true;
			let switchStatus = event.value;
			console.log('dev'+switchStatus);
			// var o = new Object();
			var cmd =1;
			if(switchStatus==false){
				cmd = 0;	
			}

			console.log('dev'+cmd);
			
			
			self.axios.post(self.scheduleUrl, {
				accesskey: self.$session.get('access_key'),
				schedule_status :cmd,
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					//var filteredarr = self.filtercategory(response.data.result);

					
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'success',
						solid: true,
						appendToast: true
					});
					self.loading = false;
					self.initload();
					
				}else{
					
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.loading = false;

				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		resetSelectedItem(){
			var self = this;
			self.selectedItem = Object.assign({}, self.emptyItem);
		},        
		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					//var filteredarr = self.filtercategory(response.data.result);

					self.records = response.data.result;
					self.loading = false;
					self.totalRows = self.records.length;
					self.firstRecord =self.records[0];

					/*const zoneOptions = arr.reduce((acc, current) => {
						const x = acc.find(item => item.value === current.value);
						if (!x) {
							return acc.concat([current]);
						} else {
							return acc;
						}
					}, []);*/
					self.zoneOptions = [];
					self.records.forEach(function(item){
						
						if(item.schedule_type==1){
							//item.schedule_type='GPS';
							const format = 'HH:mm';
							const tubeDuration = self.$moment.duration(item.tubelight_time) 
							item.on_time =  self.$moment(item.on_time, format).subtract(tubeDuration).format(format);
							item.off_time =  self.$moment(item.off_time, format).add(tubeDuration).format(format);
						}
						
						
						if(item.parent == 0){
							self.zoneOptions.push({value:item.id, text:item.title, state:item.state});
						}
						
					});
					
				}
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		/*filtercategory(records){
			var filterarr = new Array();
			records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
		},*/
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		downloadcsv(){
			var self = this;
			var header = new Array()
			self.fields.forEach(function(item){
				if(!item.extra){
					header.push(item.label);
				}
			});
			
			//var d = table.rows().data();
			var finalarr = new Array();
			finalarr.push(header);
			self.records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
			
			let csvContent = "data:text/csv;charset=utf-8," 
			+ finalarr.map(e => e.join(",")).join("\n");

			var encodedUri = encodeURI(csvContent);
			var link = document.createElement("a");
			link.setAttribute("href", encodedUri);
			link.setAttribute("download", "zone_report.csv");
			document.body.appendChild(link); // Required for FF

			link.click();
		},
		async getWeather() {
			this.weather = null;
			if (!this.city) {
				this.message = "Please select a city.";
				return;
			}
			this.message = "Loading...";
			try {
				// 1️⃣ City → Location Key
				const locationUrl = `https://dataservice.accuweather.com/locations/v1/cities/search?apikey=${this.API_KEY}&q=${this.city}`;
				const locationRes = await fetch(locationUrl);

				if (!locationRes.ok) {
				this.handleApiError(locationRes.status);
				return;
				}

				const locationData = await locationRes.json();
				if (!locationData.length) {
				this.message = "City not found.";
				return;
				}

				const locationKey = locationData[0].Key;

				// 2️⃣ Current Conditions
				const weatherUrl = `https://dataservice.accuweather.com/currentconditions/v1/${locationKey}?apikey=${this.API_KEY}&details=true`;
				const weatherRes = await fetch(weatherUrl);

				if (!weatherRes.ok) {
				this.handleApiError(weatherRes.status);
				return;
				}

				const weatherData = await weatherRes.json();
				const w = weatherData[0];

				// 3️⃣ Sunrise / Sunset
				const sunUrl = `https://dataservice.accuweather.com/forecasts/v1/daily/1day/${locationKey}?apikey=${this.API_KEY}&details=true`;
				const sunRes = await fetch(sunUrl);

				if (!sunRes.ok) {
				this.handleApiError(sunRes.status);
				return;
				}

				const sunData = await sunRes.json();
				const sun = sunData.DailyForecasts[0].Sun || null;
				this.selectedItem.name = this.city;
				this.selectedItem.on_time =sun ? new Date(sun.Set).toLocaleTimeString() : "N/A";
				this.selectedItem.off_time= sun ? new Date(sun.Rise).toLocaleTimeString() : "N/A";
				this.weather = {
				city: locationData[0].EnglishName,
				temp: w.Temperature.Metric.Value,
				feels: w.RealFeelTemperature.Metric.Value,
				condition: w.WeatherText,
				humidity: w.RelativeHumidity,
				wind: w.Wind.Speed.Metric.Value,
				sunrise: sun ? new Date(sun.Rise).toLocaleTimeString() : "N/A",
				sunset: sun ? new Date(sun.Set).toLocaleTimeString() : "N/A"
				};

				this.message = "";
			} catch (err) {
				console.error(err);
				this.message = "Network error. Check your internet connection.";
			}
			},

		handleApiError(status) {
		if (status === 401) {
			this.message = "❌ Invalid API key.";
		} else if (status === 403) {
			this.message = "⛔ API access forbidden.";
		} else if (status === 429) {
			this.message = "⚠️ API limit exceeded.";
		} else {
			this.message = "⚠️ API error.";
		}
		}
	}
}
</script>
<style>
html{
	min-height: 100%;
}
body{
	background-color: '#FFF' !important;
	background-image: none !important;
}
.table{
	font-size: small;
}
.table .btn{
	font-size: 12px;
}
.table td, .table th{
	vertical-align: middle;
}


.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}


/* ************************  */
/* .card {
  max-width: 420px;
  margin: auto;
  background: #ffffff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
}
select, button {
  width: 100%;
  padding: 12px;
  margin-top: 10px;
  font-size: 16px;
}
button {
  background: #0078d4;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
button:hover {
  background: #005ea6;
}
.weather {
  margin-top: 20px;
}
.row {
  margin-bottom: 6px;
}
.label {
  font-weight: bold;
} */
</style>